/** @module Enums */ /** typedoc */

export enum AssetPurchaseUnavailableCodeEnum {
    AlreadyMastered = 'AlreadyMastered',
    OverCompressed = 'OverCompressed',
    PaymentRequired = 'PaymentRequired',
}
